export default "__VITE_ASSET__7DnVSCSq__"